import { render, staticRenderFns } from "./EmployeeBadgeHolderList.vue?vue&type=template&id=4212342c&scoped=true"
import script from "./EmployeeBadgeHolderList.vue?vue&type=script&lang=js"
export * from "./EmployeeBadgeHolderList.vue?vue&type=script&lang=js"
import style0 from "./EmployeeBadgeHolderList.vue?vue&type=style&index=0&id=4212342c&prod&lang=css"
import style1 from "./EmployeeBadgeHolderList.vue?vue&type=style&index=1&id=4212342c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4212342c",
  null
  
)

export default component.exports